/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics. 
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>dynamic-form-question.component.ts</name>
///
/// <description>
/// A component responsible for rendering the details of each individual question based on values in the data-bound question object.
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>28 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 28Dec16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import { Component, Input } from '@angular/core';
import { FormGroup }        from '@angular/forms';
import { CUIDynamicFormQuestionBase }     from './question-base';
import { CUIFeatureInterface } from  '../../interfaces/cui-feature.interface'; 
import { TranslatedStringsService } from '../../services/language.service';

@Component({
  selector: 'df-question',
  templateUrl: './dynamic-form-question.component.html'
})
export class CUIDynamicFormQuestionComponent implements CUIFeatureInterface {
  @Input() question: CUIDynamicFormQuestionBase<any>;
  @Input() form: FormGroup;

  private label:string;
  private labelRequired:string;
  private labelInvalidFormat: string;
  private tooltip: string;
    
    constructor(
        private i18n: TranslatedStringsService 
    ) { }

    get isValid() {
        if (this.question.validationMsg != null && this.question.validationMsg != "") {
            this.labelInvalidFormat = this.question.validationMsg;
        }
        return this.form.controls[this.question.key].valid;
    }

    //----------------------------------------------------------
    // Implementations of Interface
    //----------------------------------------------------------
    //ngOnInit() {}
    ngOnChanges(changes: any) { };
    ngDoCheck() { };
    ngAfterContentInit() { };
    ngAfterContentChecked() { };
    ngAfterViewInit() { };
    ngAfterViewChecked() { };
    ngOnDestroy() { };

    public ngOnInit() {

        //this.i18n.init().then((response) => {
            this.translate();
        //});
    }

    private translate() {
   
            this.label = this.i18n.translate(this.question.label);
            this.labelRequired = this.i18n.translate("user-profile-required");
            this.labelInvalidFormat = this.i18n.translate("user-profile-invalid-format");
            this.tooltip = this.i18n.translate(this.question.tooltip);
    }

    private get isTouched(): boolean {
      return this.form.controls[this.question.key].touched;
    }

    private get isRequired(): boolean {
      return this.question.required;
    }

    private get hasValue(): boolean {
      return this.form.controls[this.question.key].value &&
             this.form.controls[this.question.key].value.length > 0 ;     
    }
 
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/shared/cui-dynamic-form/dynamic-form-question.component.ts